<template>
  <div class="min-h-screen font-sans antialiased relative">
    <div class="relative">  
      <!-- <BaseNavbar /> -->
      <main class="text-neutral-800">
        <slot />
      </main> 
    </div> 
  </div>
</template>
<script>
export default {
  name: 'EmptyLayout',
}
</script>
<script setup>
import { watch , onMounted, computed, provide} from 'vue';
const {setHeadMeta} = useCommon()
 
const isMobileComp = useIsMobile();

// isMobile.value=$device.isMobile;
const { isMobile } = useDevice();
isMobileComp.value = isMobile;
const route = useRoute();
watch(() => route.fullPath, (newValue)=>{  
  setHeadMeta(); 
})
</script>
<style>@import "~/assets/css/default.css"; @import "~/assets/css/main.css";</style>
<style lang="scss">@import "~/assets/css/main.scss";</style>
